import { useEffect, useState } from "react";
import API from "../../api"
import { Box, Grid } from "@mui/material";
import { colors } from "../../theme";
import Header from "../../components/Header";
import HighGraph from "./allLecsView-components/highGraph";
import LowGRaph from "./allLecsView-components/lowGraph";
import HighDataGrid from "./allLecsView-components/highDataGrid"
import NetworkList from "./allLecsView-components/networkList";



const AllLecsView = () => {

    const [names, setNames] = useState([]);


    useEffect(() => {
        API.getWeeklyDataLecs({ queryType: "names" }).then((result) => {
            
            setNames(result.data);
        }).catch((err) => {});
        
    }, []);

    return (
        <Box padding={"20px"}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="MULTI LECS VIEW" subtitle="" />
            </Box>
            <Grid container
                spacing={2}
                sx={{
                    display: "flex",
                    justifyContent: "left",
                    paddingBottom: 10
                }}>
                <Grid size={7}>
                    <HighGraph
                        names={names}
                        colors={colors}
                    />
                </Grid>
                <Grid size={5}>
                    <LowGRaph
                        names={names}
                    />
                </Grid>
                <Grid height={"70vh"} size={9}>
                    <HighDataGrid
                        names={names}
                        colors={colors}
                    />
                </Grid>
                <Grid size={3}>
                    <NetworkList 
                        names={names}
                    />
                </Grid>
            </Grid>
        </Box>
    );


}

export default AllLecsView;